import { combineReducers } from 'redux'

import rotation from './rotation'
import pageSettings from './pageSettings'
import unit from './unit'

export default combineReducers({
  rotation,
  pageSettings,
  unit,
})
